/* eslint-disable no-shadow */
import {
  REMOVE_FROM_ROUTE_NAME,
  SET_FROM_ROUTE_NAME,
} from '@/store/actions/router';
import { PATIENT_PAGES, EMPLOYEE_PAGES } from '@/mixins/branchMixin';

const state = {
  from_route: null,
};

const getters = {
  getFromRoute: () => state.from_route,
};

const actions = {
  [SET_FROM_ROUTE_NAME]: ({ commit }, { from, to }) => {
    if (
      (PATIENT_PAGES.includes(to.name) || EMPLOYEE_PAGES.includes(to.name))
      && (!PATIENT_PAGES.includes(from.name) && !EMPLOYEE_PAGES.includes(from.name))
    ) {
      commit(SET_FROM_ROUTE_NAME, from);
    }
  },
  [REMOVE_FROM_ROUTE_NAME]: ({ commit }) => {
    commit(REMOVE_FROM_ROUTE_NAME);
  },
};

const mutations = {
  [SET_FROM_ROUTE_NAME]: (state, from) => {
    state.from_route = from;
  },
  [REMOVE_FROM_ROUTE_NAME]: (state) => {
    state.from_route = null;
  },
};

export default () => ({
  state,
  getters,
  actions,
  mutations,
});
